<template>
  <Card>
    <LocalDataTable :columns="columns" :ajax-link="ajaxLink"></LocalDataTable>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import LocalDataTable from "@/components/LocalDataTable";
export default {
name: "AuctionRequestManage",
  components: {LocalDataTable, Card},
  data()
  {
    return{
      columns:[
          {title : 'شماره'},
          {title : 'درخواست دهنده'},
          {title : 'تاریخ'},
          {title : 'محصول'},
          {title : 'ویژگی'},
          {title : 'وضعیت'},
          {title : 'تعداد پیشنهاد'},
          {title : '<i class="far fa-cogs"></i>'},
          ],
      ajaxLink :'admin/AuctionRequest/List'
    }
  },
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('درخواست های مزایده');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>